import "regenerator-runtime/runtime";
import _asyncToGenerator from "/bitrise/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
import { apolloClient } from '@/apollo/apolloClient';
import { GET_USER } from '@/apollo/queries/user-query';
import { getUserUID, getZoneId } from "../../utils/auth";
var state = {
  myUser: []
};
var mutations = {
  CREATE_USER_BY_UID: function CREATE_USER_BY_UID(state, data) {
    var user = data.user;

    if (user) {
      user.companyCount = '';
      user.companyName = '';
      user.companyID = '';
      user.roleName = '';
      user.roleID = '';

      if (user.role) {
        user.roleName = user.role.name;
        user.roleID = user.role.id;
      }

      user.planMaxUser = '';
      user.planName = '';

      if (user.zone) {
        if (user.zone.plan) {
          user.planMaxUser = user.zone.plan.max_user;
          user.planName = user.zone.plan.name;
        }

        user.companyName = user.zone.name;
      }

      user.companyCount = data.user_aggregate.aggregate.count;
      user.companyID = getZoneId();
    }

    state.myUser = user;
  }
};
var actions = {
  getMyUser: function () {
    var _getMyUser = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              _context.t0 = apolloClient;
              _context.t1 = GET_USER;
              _context.next = 5;
              return getUserUID();

            case 5:
              _context.t2 = _context.sent;
              _context.next = 8;
              return getZoneId();

            case 8:
              _context.t3 = _context.sent;
              _context.t4 = {
                uid: _context.t2,
                zoneId: _context.t3
              };
              _context.t5 = {
                query: _context.t1,
                variables: _context.t4
              };
              _context.next = 13;
              return _context.t0.query.call(_context.t0, _context.t5);

            case 13:
              res = _context.sent;

              if (!res.data) {
                _context.next = 19;
                break;
              }

              commit('CREATE_USER_BY_UID', res.data);
              return _context.abrupt("return", res.data.user);

            case 19:
              throw res.errors[0].message;

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getMyUser(_x) {
      return _getMyUser.apply(this, arguments);
    }

    return getMyUser;
  }()
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};